"use strict";
require("./..\\..\\..\\bower_components\\parsleyjs\\dist\\parsley.js");
require("./..\\..\\..\\bower_components\\parsleyjs\\dist\\i18n\\ru.js");
require("./..\\..\\..\\bower_components\\magnific-popup\\dist\\jquery.magnific-popup.js");

module.exports = function () {
 
	$('form').each(function(){
		var $form = $(this),
		$submitButton = $form.find('[type="submit"]');
		var $name=$form.find('[type="text"]');
		var $email=$form.find('[type="email"]');
		var $phone=$form.find('.input_type_phone');
		var $message=$form.find('.input_type_textarea');
		var $goal=$submitButton.data( 'goal' );
		
		$form.on('submit', function(e){
			e.preventDefault();
			
			yaCounter47433673.reachGoal($goal);

			if ($form.parsley().isValid()) {
				$submitButton.prop('disabled', true);
				$.ajax({
					type: "post",
					url: "/ajax/feedback",
					data:{email:$email.val(),phone:$phone.val(),name:$name.val(),message:$message.val()},
					dataType:"json",
					success:function (data, textStatus) {
						if (data['error']){
							$.magnificPopup.open({
								items: {
									src: '#feedback_fail',
									type: 'inline'
								}
							});								
						} else{
							$.magnificPopup.open({
								items: {
									src: '#feedback_success',
									type: 'inline'
								}
							});								
						}
				  

					},
					error: function(message,type){			
						$.magnificPopup.open({
							items: {
								src: '#feedback_fail',
								type: 'inline'
							}
						});		
					}
				});   			
				// clear fields
				$email.val("");
				$name.val("");
				$phone.val("");
				$message.val("");
				
				$submitButton.prop('disabled', false);
				

			}
		});
	});

};